import { schema } from "normalizr";

const PermissionSchema = new schema.Entity("permissions");
const PermissionArraySchema = new schema.Array(PermissionSchema);

export { PermissionSchema, PermissionArraySchema };